import * as React from "react";
import MassConfigPremisesComponentsPreviewForm from "../../components/Forms/MassConfigPremisesComponents/PreviewForm/PreviewForm";

export default function MassConfigPreview() {
  return <MassConfigPremisesComponentsPreviewForm />;
}
